import dayjs from "dayjs";

/**
 * Checks if a given date is expired.
 * @param {string | number | null | undefined} dateValue - The date to check (ISO string or timestamp).
 * @returns {boolean} - Returns true if the date is expired, false otherwise.
 */
export const isDateExpired = (dateValue?: string | number | null): boolean => {
  if (!dateValue) return false;

  const date = dayjs(dateValue);

  // Check if the parsed date is valid before comparing
  return date.isValid() && date.isBefore(dayjs());
};
